<template>
  <nav class="pagination" role="navigation" aria-label="pagination" v-if="pages.length">
    <ul class="pagination-list">
      <li v-for="num in pages" :key="num">
        <span class="pagination-ellipsis" v-if="num === null">&hellip;</span>
        <a class="pagination-link" v-else @click="goto(num)" :class="{ 'is-current': page === num }">
          <div class='pagination-text'>{{ num }}</div>
        </a>
      </li>
    </ul>
    <div class='pagination-list'>
      <a class="pagination-previous" @click="goto(page - 1)">
        <div class="pagination-text icon">
          <font-awesome-icon icon="backward" />
        </div>
      </a>
      <a class="pagination-previous" @click="goto(1)">
        <div class="pagination-text icon">
          <font-awesome-icon icon="backward-step" />
        </div>
      </a>
      <a class="pagination-next" @click="goto(count)">
        <div class="pagination-text icon">
          <font-awesome-icon icon="step-forward" />
        </div>
      </a>
      <a class="pagination-next" @click="goto(page + 1)">
        <div class="pagination-text icon">
          <font-awesome-icon icon="forward" />
        </div>
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 20
    },
    total: {
      type: Number,
      default: 0
    }
  },
  computed: {
    count() {
      return Math.ceil(this.total / this.perPage);
    },
    pages() {
      let pages = [];
      const count = this.count;

      if (count <= 1) return pages;

      if (count <= 5) {
        return [...Array(count).keys()].map(p => ++p);
      }

      pages = Array(7).fill(null);
      pages[0] = 1;
      pages[6] = count;

      if (this.page > count - 4) {
        for (let i = 1, end = 6; i < end - 1; i++) {
          pages[end - i] = count - i;
        }
      } else if (this.page <= 4) {
        for (let i = 1, end = 6; i < end - 1; i++) {
          pages[i] = i + 1;
        }
      } else {
        pages[2] = this.page - 1;
        pages[3] = this.page;
        pages[4] = this.page + 1;
      }

      return pages;
    }
  },
  watch: {
    page() {
      this.checkCurrentPage();
    },
    count() {
      this.checkCurrentPage();
    }
  },
  methods: {
    goto(page) {
      if (page >= 1 && page <= this.count && page !== this.page) {
        this.$emit("input", page);
      }
    },
    checkCurrentPage() {
      if (this.page > this.count) this.goto(1);
    }
  },
  mounted() {
    this.checkCurrentPage();
  }
};
</script>

<style lang="scss" scoped>
@use "../scss/variables" as *;

.pagination {
  align-items: center;
  display: flex;
  text-align: center;
  margin: 2rem 0;
  justify-content: space-between;

  @media (max-width: $mobile) {
    flex-wrap: wrap-reverse;
    justify-content:center;
    gap:10px;
  }
}

.pagination-right,
.pagination-list {
  display: flex;
  gap: 10px;
}

.pagination-text {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 40px;
  box-shadow: 0 .0625em .125em hsla(0, 0%, 20%, 0.05), 0 .125em .25em hsla(0, 0%, 20%, 0.05);
 
}

.pagination-text.icon {
   @media (max-width: $mobile) {
    min-width: 60px;
  }
}

.pagination-link,
.pagination-previous,
.pagination-next {
  display: inline-flex;
  background-color: var(--match-card-color);
  transition: all 0.2s linear;
  align-items: center;
  border-color: transparent;
  border-radius: 7px;
  overflow: hidden;

  &.is-current {
    background-color: var(--match-card-header-color);
    cursor: default;
  }

  &:hover {
    background-color: var(--match-card-header-color);
  }
}

.pagination-ellipsis {
  padding: 0 0.1rem;
}
</style>
